import type {
  ApiResponse,
  BlogPost,
  BlogPostSummary,
  PricingPlan,
  SiteContent,
} from '@saas-bot/types';

// Unset or empty means same-origin: dev goes through the Vite proxy, prod
// through the reverse proxy. An absolute URL is only for a split-host deploy.
const API_URL = import.meta.env.VITE_API_URL || '/api';

export async function fetchSiteContent(signal?: AbortSignal): Promise<SiteContent | null> {
  try {
    const response = await fetch(`${API_URL}/public/site`, { signal });
    if (!response.ok) return null;
    const body = (await response.json()) as ApiResponse<SiteContent>;
    return body.data ?? null;
  } catch {
    return null;
  }
}

export async function fetchPosts(signal?: AbortSignal): Promise<BlogPostSummary[]> {
  try {
    const response = await fetch(`${API_URL}/public/cms/posts`, { signal });
    if (!response.ok) return [];
    const body = (await response.json()) as ApiResponse<BlogPostSummary[]>;
    return body.data ?? [];
  } catch {
    return [];
  }
}

export async function fetchPricing(signal?: AbortSignal): Promise<PricingPlan[]> {
  try {
    const response = await fetch(`${API_URL}/public/cms/pricing`, { signal });
    if (!response.ok) return [];
    const body = (await response.json()) as ApiResponse<PricingPlan[]>;
    return body.data ?? [];
  } catch {
    return [];
  }
}

export async function fetchPost(slug: string, signal?: AbortSignal): Promise<BlogPost | null> {
  try {
    const response = await fetch(`${API_URL}/public/cms/posts/${slug}`, { signal });
    if (!response.ok) return null;
    const body = (await response.json()) as ApiResponse<BlogPost>;
    return body.data ?? null;
  } catch {
    return null;
  }
}
